<div id="watermark" [innerHTML]="'LICENCES.EXPIRED_LICENCE' | translate: {br: '<br/>'}">
</div>

<ion-app>
  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>
<div id="meetingSDKElement">
  <!-- Zoom Meeting SDK Component View Rendered Here -->
</div>
